import styled from 'styled-components';

const CartItemFavorite = styled.div`
  margin: 0.2rem 0;
`;

export default CartItemFavorite;
